import RankingItem from "./RankingItem";

export default function Rankings({ name, rankings, rankMatchesIndices, onRankChange = () => {}, pIndices,sectionIndices }) {
  return rankings.map((ranking, index) => (
    <div className="col" key={pIndices ? pIndices[index] : index}>
      <RankingItem
        name={name}
        pIndex={pIndices ? pIndices[index] : index}
        ranking={ranking}
        rankMatchesIndices={rankMatchesIndices}
        onRankChange={onRankChange}
        sectionIndices={sectionIndices ? sectionIndices[index] : index}
      />
    </div>
  ));
}
